import React, {useEffect, useState} from 'react';
import "./Navbar.css";
import {Button, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import {useCookies} from 'react-cookie';

import Logo from '../../assets/solutrak-logo.png';
import Photo from '../../assets/profile-icon.png';
import NotificationIcon from "../../assets/notification-icon.png";
import PasswordIcon from '../../assets/change-password-icon.png';
import PowerIcon from '../../assets/power-icon.png';
import EditIcon from '../../assets/edit-info-icon.png';

import ChangePasswordModal from '../ChangePasswordModal/Modal.js';
import ImpersonationDropDown from '../ImpersonationDropdown/ImpersonationDropdown.js';
import ROUTES from "../../../utils/constants/endpoints";
import API, {clearSession} from "../../../services/http";


function Navbars() {
    const [cookies, _, removeCookie] = useCookies();
    const [pPicture, setPPicture] = useState(cookies.profilePictureUrl || Photo);
    const navigate = useNavigate();
    const [showChangePassword, setShowChangePassword] = useState(false);


    // Handle image load error
    useEffect(() => {
        const img = new Image();
        img.src = cookies.profilePictureUrl;
        img.onerror = () => setPPicture(Photo);
    }, [cookies.profilePictureUrl]);

    const handleLogout = async () => {
        try {
            await API.post('/accounts/signOut');
        } catch (error) {
            console.error("Logout failed:", error);
        } finally {
           clearSession(removeCookie, navigate);
        }
    };

    return (
        <Navbar data-bs-theme="dark">
            <div className="navbar-container">
                {/* Logo */}
                <Navbar.Brand href={ROUTES.DASHBOARD}>
                    <img src={Logo} alt="logo" className='solutrak-logo' />
                </Navbar.Brand>

                <Nav className="ml-auto d-flex align-items-center">
                    {/* Impersonation Dropdown (for Admins) or Company Name Button (for Others) */}
                    <Nav.Item className='me-4'>
                        {cookies.userType === 'admin' ? (
                            <ImpersonationDropDown />
                        ) : (
                            <Button
                                variant="warning"
                                className="btn fw-bold"
                                style={{ backgroundColor: '#ffc107' }}
                                disabled
                            >
                                {cookies.company}
                            </Button>
                        )}
                    </Nav.Item>

                    {/* Notifications Icon */}
                    <Nav.Item className='me-4'>
                        <Nav.Link className="navbar-links" href={ROUTES.ALERTS}>
                            <img src={NotificationIcon} alt='Notifications' className='notif-icon' />
                        </Nav.Link>
                    </Nav.Item>

                    {/* Profile Dropdown */}
                    <Nav.Item>
                        <NavDropdown
                            align='end'
                            title={<img src={pPicture} alt="Profile" className='profile-photo' />}
                            id="profile-dropdown"
                        >
                            <div className="!w-56 !p-2">
                                {/* Edit Profile */}
                                <NavDropdown.Item href={ROUTES.PROFILE} className="dropdown-item d-flex gap-2 mb-2">
                                    <img src={EditIcon} alt="Edit Profile" className="dropdown-icon" />
                                    Edit Profile
                                </NavDropdown.Item>

                                {/* Change Password */}
                                <NavDropdown.Item onClick={() => setShowChangePassword(true)} className="dropdown-item d-flex gap-2">
                                    <img src={PasswordIcon} alt="Change Password" className="dropdown-icon" />
                                    <span>Change Password</span>
                                </NavDropdown.Item>

                                <NavDropdown.Divider />

                                {/* Logout */}
                                <NavDropdown.Item onClick={handleLogout} className="dropdown-item d-flex gap-2">
                                    <img src={PowerIcon} alt="Logout" className="dropdown-icon" />
                                    Logout
                                </NavDropdown.Item>
                            </div>
                        </NavDropdown>
                    </Nav.Item>
                </Nav>
            </div>

            {/* Change Password Modal */}
            <ChangePasswordModal show={showChangePassword} onHide={() => setShowChangePassword(false)} />
        </Navbar>
    );
}

export default Navbars;
